import { Alert } from "@/components/ui/alert";
import {translate} from ".././../../../utils/Common"

const SuccessPickUp = ({ setSuccessPickUp, pickUpPackagesFound, setPickUpPackagesFound }) => {
    const handleBack = () => {
        setPickUpPackagesFound([]);
        setSuccessPickUp(false);
    }

    return (
        <div className="flex flex-wrap -mx-2 text-center flex justify-center flex-col dashboardCard py-0" >
            <Alert variant='success' className="w-12/12 my-4">
                <h2>{translate("dashboard.packages.pickUp.success.title" )}</h2>
                <p className="mb-1">
                    {translate("dashboard.packages.pickUp.success.description")}:
                </p>
                { pickUpPackagesFound?.map((paquete, index) => <p className="mb-0 font-semibold" key={ index }>{ paquete.Nro_Id }</p>) }
                <p className="mt-1 mb-1">
                    {translate("dashboard.packages.pickUp.success.email")}
                </p>
            </Alert>

            <div className="w-12/12 mb-4">
                <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 btn-md bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" type="button" onClick={ () => handleBack() }>
                    {translate("global.accept")}
                </button>
            </div>
        </div>
    );
}

export default SuccessPickUp;